import WidgetType from '@/enums/WidgetType';

const state = {
  displayableWithCategory: true
};

const mutations = {
  SET_WIDGET_DISPLAYABLE_WITH_CATEGORY(state, displayable) {
    state.displayableWithCategory = displayable;
  }
};

const actions = {
  fetchDisplayableWithCategory(
    { commit, rootState },
    { widget_id, category_code, product_code, preview, widget_type }
  ) {
    if (preview) return;
    if (
      ![WidgetType.PRODUCT_REVIEWS, WidgetType.CATEGORY_REVIEWS].includes(
        widget_type
      )
    )
      return;

    return rootState.api
      .fetchDisplayableWithCategory({
        widget_id,
        category_code,
        product_code
      })
      .then(({ data }) => {
        commit('SET_WIDGET_DISPLAYABLE_WITH_CATEGORY', data.displayable);
      });
  }
};

export default { namespaced: true, state, mutations, actions };
